export const hasPermission = (viewPerms, permission) => {
  return viewPerms && viewPerms[permission] === 'granted';
};
